import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  HomeIcon, UserGroupIcon, UsersIcon, CurrencyDollarIcon, CalendarIcon, AcademicCapIcon, ChartBarIcon,
  CogIcon, ArrowLeftOnRectangleIcon, BookOpenIcon, ClipboardDocumentListIcon, DocumentTextIcon, TicketIcon, FilmIcon,
} from '@heroicons/react/24/outline';
const logo = '/images/quantanova.png';
const logoH = '/images/QuantaNovaLogo.jpeg';


const Sidebar = ({ isOpen, setIsOpen, isCollapsed }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const getNavigationItems = () => {
    const baseItems = [
      { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
    ];

    const roleBasedItems = {
      admin: [
        { name: 'Students', href: '/students', icon: UserGroupIcon },
        { name: 'Admissions', href: '/admissions', icon: DocumentTextIcon },
        { name: 'Employees', href: '/employees', icon: UsersIcon },
        { name: 'Classes', href: '/classes', icon: AcademicCapIcon },
        // { name: 'Sections', href: '/sections', icon: RectangleGroupIcon },
        { name: 'Fees', href: '/fees', icon: CurrencyDollarIcon },
        { name: 'Coupons', href: '/coupons', icon: TicketIcon },
        { name: 'Lectures', href: '/lectures', icon: DocumentTextIcon },
        { name: 'Analysis', href: '/analysis', icon: ChartBarIcon },
        { name: 'Attendance', href: '/attendance', icon: CalendarIcon },
        { name: 'Parents', href: '/parents', icon: UsersIcon },
        // { name: 'Exams', href: '/exams', icon: BookOpenIcon },
        // { name: 'Reports', href: '/reports', icon: ChartBarIcon },
        // { name: 'Settings', href: '/settings', icon: CogIcon },
      ],
      management: [
        { name: 'Students', href: '/students', icon: UserGroupIcon },
        { name: 'Admissions', href: '/admissions', icon: DocumentTextIcon },
        { name: 'Employees', href: '/employees', icon: UsersIcon },
        { name: 'Classes', href: '/classes', icon: AcademicCapIcon },
        // { name: 'Sections', href: '/sections', icon: RectangleGroupIcon },
        { name: 'Fees', href: '/fees', icon: CurrencyDollarIcon },
        { name: 'Analysis', href: '/analysis', icon: ChartBarIcon },
        { name: 'Attendance', href: '/attendance', icon: CalendarIcon },
        // { name: 'Exams', href: '/exams', icon: BookOpenIcon },
        // { name: 'Reports', href: '/reports', icon: ChartBarIcon },
      ],
      accountant: [
        { name: 'Students', href: '/students', icon: UserGroupIcon },
        { name: 'Fees', href: '/fees', icon: CurrencyDollarIcon },
        // { name: 'Reports', href: '/reports', icon: ChartBarIcon },
      ],
      teacher: [
        { name: 'Students', href: '/students', icon: UserGroupIcon },
        { name: 'Classes', href: '/classes', icon: AcademicCapIcon },
        { name: 'Admissions', href: '/admissions', icon: DocumentTextIcon },
        { name: 'Employees', href: '/employees', icon: UsersIcon },
        { name: 'Fees', href: '/fees', icon: CurrencyDollarIcon },
        { name: 'Coupons', href: '/coupons', icon: TicketIcon },
        // { name: 'Sections', href: '/sections', icon: RectangleGroupIcon },
        { name: 'Attendance', href: '/attendance', icon: CalendarIcon },
        // { name: 'Exams', href: '/exams', icon: BookOpenIcon },
        // { name: 'My Classes', href: '/my-classes', icon: ClipboardDocumentListIcon },
        { name: 'Lectures', href: '/lectures', icon: FilmIcon },
        { name: 'Analysis', href: '/analysis', icon: ChartBarIcon },
        { name: 'Parents', href: '/parents', icon: ChartBarIcon },
      ],
      student: [
        // { name: 'My Attendance', href: '/my-attendance', icon: CalendarIcon },
        { name: 'My Exams', href: '/my-exams', icon: AcademicCapIcon },
        { name: 'My Fees', href: '/my-fees', icon: CurrencyDollarIcon },
        { name: 'Assignments', href: '/assignments', icon: ClipboardDocumentListIcon },
      ],
      parent: [
        { name: 'Children', href: '/children', icon: UserGroupIcon },
        { name: 'Attendance', href: '/attendance', icon: CalendarIcon },
        { name: 'Exams', href: '/exams', icon: AcademicCapIcon },
        { name: 'Fees', href: '/fees', icon: CurrencyDollarIcon },
      ],
    };

    return [...baseItems, ...(roleBasedItems[user?.role] || [])];
  };

  const navigationItems = getNavigationItems();

  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div className="sidebar-backdrop lg:hidden" onClick={() => setIsOpen(false)} />
      )}

      {/* Sidebar */}
      <div className={`sidebar-wrapper ${isOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-container">
          {/* Logo Section */}
          <div className="sidebar-logo">
            {isCollapsed && <img src={logo} alt="School Logo" className="sidebar-logo-img" />}
            {!isCollapsed && (
            <img src={logoH} alt="School Logo" className="sidebar-logoH-img" />
            )}

          </div>

          {/* Navigation */}
          <nav className="sidebar-nav">
            {navigationItems.map((item) => (
              <NavLink key={item.name} to={item.href}
                className={({ isActive }) =>
                  `sidebar-nav-item ${isActive ? 'active' : ''}`
                }
                onClick={() => setIsOpen(false)} title={isCollapsed ? item.name : ''} >
                <item.icon className="sidebar-nav-icon" aria-hidden="true" />
                <span>{item.name}</span>
              </NavLink>
            ))}
          </nav>

          {/* Logout */}
          <div className="sidebar-logout">
            <button onClick={handleLogout} className="sidebar-logout-btn" title={isCollapsed ? 'Logout' : ''}>
              <ArrowLeftOnRectangleIcon className="sidebar-logout-icon" aria-hidden="true" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;